const GRADIENT_PREFIXES = ['linear-gradient', 'radial-gradient'];

/**
 * Checks if a value is a CSS gradient (starts with linear-gradient, radial-gradient, etc.)
 */
export const isGradient = (value: string): boolean => {
  if (!value) return false;
  const trimmed = value.trim();
  return GRADIENT_PREFIXES.some((prefix) => trimmed.startsWith(prefix));
};

/**
 * Returns the appropriate style object for a color or gradient value
 * Uses 'background' for gradients and 'backgroundColor' for solid colors
 */
export const getBackgroundStyle = (value: string): { background?: string; backgroundColor?: string } => {
  if (!value) return {};

  if (isGradient(value)) {
    return { background: value };
  }

  return { backgroundColor: value };
};
